/* ============================================================
   SPORTIVE PRODUCT PAGE ENHANCEMENTS
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     STICKY ATC BAR
     Shows when the main buy button scrolls out of view
     ---------------------------------------------------------- */
  function initStickyATC() {
    const bar = document.getElementById('sportive-sticky-atc');
    if (!bar) return;

    const mainForm = document.querySelector('button[name="add"].product-form__submit');
    if (!mainForm) return;

    const stickyBtn = bar.querySelector('.sportive-sticky-atc__btn');
    const stickyVariant = bar.querySelector('.sportive-sticky-atc__variant');
    const stickyPrice = bar.querySelector('.sportive-sticky-atc__price');

    // Show/hide bar based on main button visibility
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
            bar.setAttribute('inert', '');
          } else {
            bar.classList.add('is-visible');
            bar.removeAttribute('aria-hidden');
            bar.removeAttribute('inert');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );
    observer.observe(mainForm);

    // Mirror disabled state from Add to Cart to sticky button in real time
    const atcObserver = new MutationObserver(function () {
      stickyBtn.disabled = mainForm.disabled;
      if (!mainForm.disabled && stickyBtn.textContent === 'Buy Now' || stickyBtn.textContent === '') {
        stickyBtn.textContent = 'Buy Now';
      }
    });
    atcObserver.observe(mainForm, { attributes: true, attributeFilter: ['disabled'] });

    // Sync sticky button text/sold-out state
    function syncState() {
      stickyBtn.disabled = mainForm.disabled;
      const disabledText = mainForm.querySelector('[data-sold-out-message]');
      if (disabledText && getComputedStyle(disabledText).display !== 'none') {
        stickyBtn.textContent = disabledText.textContent.trim() || 'Sold Out';
      } else if (!stickyBtn.disabled) {
        stickyBtn.textContent = 'Buy Now';
      }
    }

    // Sync variant label with current selection
    function syncVariant() {
      if (!stickyVariant) return;
      const variantPicker = document.querySelector('variant-selects, variant-radios');
      if (!variantPicker) return;

      const selected = [];
      variantPicker.querySelectorAll('select').forEach(function (sel) {
        if (sel.value) selected.push(sel.options[sel.selectedIndex].text);
      });
      variantPicker.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        selected.push(radio.value);
      });

      stickyVariant.textContent = selected.join(' / ');
    }

    // Sync price
    function syncPrice() {
      if (!stickyPrice) return;
      const priceEl = document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
      if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();
    }

    // Submit from sticky bar — add to cart then go to checkout
    stickyBtn.addEventListener('click', function () {
      const variantInput = document.querySelector('input.product-variant-id');
      if (!variantInput || !variantInput.value) return;
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'Loading…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        stickyBtn.disabled = false;
        stickyBtn.textContent = 'Buy Now';
      });
    });

    // Listen for variant changes
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios')) {
        setTimeout(function () {
          syncVariant();
          syncState();
          syncPrice();
        }, 100);
      }
    });

    // Initial sync
    syncVariant();
    syncState();
    syncPrice();
  }

  /* ----------------------------------------------------------
     DELIVERY ESTIMATE
     Dynamic: cutoff 14:00 local time, skip weekends
     ---------------------------------------------------------- */
  function initDeliveryEstimate() {
    const el = document.getElementById('sportive-delivery-estimate');
    if (!el) return;

    const now = new Date();
    const hour = now.getHours();
    const cutoff = 14; // 2pm
    const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(date, days) {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }

    function formatDate(date) {
      return DAYS[date.getDay()] + ', ' + MONTHS[date.getMonth()] + ' ' + date.getDate();
    }

    let deliveryDate;
    let orderText;

    const isWeekend = now.getDay() === 0 || now.getDay() === 6;

    if (!isWeekend && hour < cutoff) {
      const remaining = cutoff - hour;
      orderText = 'Order in the next ' + remaining + ' hour' + (remaining === 1 ? '' : 's');
      deliveryDate = addBusinessDays(now, 2);
    } else {
      orderText = 'Order by tomorrow';
      deliveryDate = addBusinessDays(now, isWeekend ? 3 : 3);
    }

    el.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
      '<span>' + orderText + ' — estimated delivery <strong>' + formatDate(deliveryDate) + '</strong></span>';

    el.classList.remove('loading');
  }

  /* ----------------------------------------------------------
     BACK IN STOCK FORM
     Shows/hides based on variant availability
     ---------------------------------------------------------- */
  function initBackInStock() {
    const wrapper = document.getElementById('sportive-back-in-stock');
    if (!wrapper) return;

    const form = wrapper.querySelector('.sportive-back-in-stock__form');
    const btn = wrapper.querySelector('.sportive-back-in-stock__btn');
    const successMsg = wrapper.querySelector('.sportive-back-in-stock__success');
    const input = wrapper.querySelector('.sportive-back-in-stock__input');

    function setVisibility(isSoldOut) {
      if (isSoldOut) {
        wrapper.classList.add('is-visible');
      } else {
        wrapper.classList.remove('is-visible');
      }
    }

    function checkBtn() {
      const mainBtn = document.querySelector('.product-form__submit');
      if (!mainBtn) return;
      setVisibility(mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true');
    }

    // MutationObserver — watches the buy button for disabled changes directly
    function observeBtn() {
      const mainBtn = document.querySelector('.product-form__submit');
      if (!mainBtn) return;
      const mo = new MutationObserver(function () { checkBtn(); });
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    // Fallback: variant:change event
    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && (e.detail.variant || (e.detail.data && e.detail.data.variant));
      if (variant !== undefined && variant !== null) {
        setVisibility(!variant.available);
      } else {
        setTimeout(checkBtn, 300);
      }
    });

    // Handle form submission
    if (form && btn) {
      btn.addEventListener('click', function () {
        const email = input ? input.value.trim() : '';
        if (!email || !email.includes('@')) {
          if (input) input.focus();
          return;
        }

        btn.textContent = '...';
        btn.disabled = true;

        // Get current product/variant info from page
        const productId = document.querySelector('[data-product-id]')
          ? document.querySelector('[data-product-id]').dataset.productId
          : '';
        const variantInput = document.querySelector('input[name="id"]');
        const variantId = variantInput ? variantInput.value : '';

        // Log to console (connect to your email app — Klaviyo, Mailchimp etc.)
        console.log('[Back in Stock] Email:', email, 'Product:', productId, 'Variant:', variantId);

        // Show success
        setTimeout(function () {
          if (form) form.style.display = 'none';
          if (successMsg) successMsg.classList.add('is-visible');
        }, 600);
      });
    }

    // Initial check + start watching the button for changes
    setTimeout(function () { checkBtn(); observeBtn(); }, 800);
  }

  /* ----------------------------------------------------------
     RECENTLY VIEWED
     Stores product data in localStorage, renders on page load
     ---------------------------------------------------------- */
  const RECENTLY_VIEWED_KEY = 'sportive_recently_viewed';
  const MAX_RECENTLY_VIEWED = 8;

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveCurrentProduct() {
    const dataEl = document.getElementById('sportive-current-product-data');
    if (!dataEl) return;

    try {
      const product = JSON.parse(dataEl.textContent);
      if (!product || !product.id) return;

      let viewed = getRecentlyViewed();
      viewed = viewed.filter(function (p) { return p.id !== product.id; });
      viewed.unshift(product);
      viewed = viewed.slice(0, MAX_RECENTLY_VIEWED);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    const container = document.getElementById('sportive-recently-viewed');
    if (!container) return;

    const currentId = container.dataset.productId;
    const viewed = getRecentlyViewed().filter(function (p) {
      return String(p.id) !== String(currentId);
    });

    if (viewed.length === 0) return;

    const grid = container.querySelector('.sportive-recently-viewed__grid');
    if (!grid) return;

    const toShow = viewed.slice(0, 4);
    grid.innerHTML = toShow.map(function (p) {
      const price = p.price ? (p.price / 100).toFixed(2) : '';
      return '<a href="' + p.url + '" class="sportive-recently-viewed__item">' +
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" class="sportive-recently-viewed__item-image" loading="lazy">' : '') +
        (p.vendor ? '<p class="sportive-recently-viewed__item-vendor">' + p.vendor + '</p>' : '') +
        '<p class="sportive-recently-viewed__item-title">' + p.title + '</p>' +
        (price ? '<p class="sportive-recently-viewed__item-price">$' + price + '</p>' : '') +
        '</a>';
    }).join('');

    container.classList.add('is-visible');
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    saveCurrentProduct();
    initStickyATC();
    initDeliveryEstimate();
    initBackInStock();
    renderRecentlyViewed();
  });

})();
